module.exports = __webpack_public_path__ + "img/mic-off.c1d105c6.svg";